import { render, staticRenderFns } from "./Formula.vue?vue&type=template&id=891650b0&"
import script from "./Formula.vue?vue&type=script&lang=ts&"
export * from "./Formula.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports